import { propertyValue } from './dood-block-config';
import { doodModalConfig } from './dood-modal-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const COMOUSECREDITBALANCEMODAL_LEGACY_FIELD_ORDER = [
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  comoUseCreditBalanceModalDescriptor: _generatedComoUseCreditBalanceModalDescriptor,
  comoUseCreditBalanceModalModalDefinition,
  comoUseCreditBalanceModalDashboardLayout,
  comoUseCreditBalanceModalConfig,
  comoUseCreditBalanceModalResolveConfig,
  comoUseCreditBalanceModalProperties,
} = doodModalConfig(
  {
    name: "Como - Use credit balance modal",
    handle: "como-use-credit-balance-modal",
    internal_name: "ComoUseCreditBalanceModal",
    componentType: 'ComoUseCreditBalanceModalComponent',
    category: 'modal',
    description: "Como - Use credit balance modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "como-use-credit-balance-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color"],
          },
        ],
      },
    ],
  })
);

export function comoUseCreditBalanceModalDescriptor(): IBlockDescriptor;
export function comoUseCreditBalanceModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoUseCreditBalanceModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoUseCreditBalanceModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedComoUseCreditBalanceModalDescriptor, comoUseCreditBalanceModalProperties, fieldOrder);
}

export {
  comoUseCreditBalanceModalModalDefinition,
  comoUseCreditBalanceModalDashboardLayout,
  comoUseCreditBalanceModalProperties,
  comoUseCreditBalanceModalConfig,
  comoUseCreditBalanceModalResolveConfig,
};

export type ComoUseCreditBalanceModalConfig = typeof comoUseCreditBalanceModalConfig;
